import { lazy } from 'react';

const TrackingRoutes = [
  {
    path: 'tracking',
    component: lazy(() =>
      import('views/order-management/tracking/TrackingListPage'),
    ),
  },
];

export default TrackingRoutes;
